/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { EnduranceMenu } from '../lists/endurance.menu';
import { EnduranceRBACResourcesApiService } from '../http';
import { Injectable } from '@angular/core';
import { MenuConfigModel } from '../../../../core/models';
import { Observable } from 'rxjs';
import { RbacService, UtilsService } from '../../../../core/services';

@Injectable()
export class EnduranceRbacMenuResolvers {
    constructor(
        private enduranceRBACResourcesApiService: EnduranceRBACResourcesApiService,
        private rbacService: RbacService,
        private utilsService: UtilsService
    ) {
    }

    /**
     * Resolve RBAC Routes and set menu permission, return formatted menu to caller.
     */
    public resolve(): Observable<any> {
        return new Observable<any>(observe => {
            this.enduranceRBACResourcesApiService.getRoutesForCurrentUser()
                .subscribe({
                    next: (data: any): void => {
                        this.rbacService.endpointsLookup = this.utilsService.sortArrayByProperty(data, 'path');
                        const menu: MenuConfigModel = this.rbacService.formatMenuPermissions(EnduranceMenu);

                        observe.next(menu);
                        observe.complete();
                    },
                    error: () => {
                        observe.next([]);
                        observe.complete();
                    }
                });
        });
    }
}
